import {Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import withAttr from 'flarum/common/utils/withAttr';
import FormGroup from '../components/FormGroup';
import RichTextField from '../components/RichTextField';
import {AutomaticDiscussionOptions} from '../models/JsonTypes';

const translationPrefix = 'kilowhat-formulaire.forum.auto-discussion-options-modal.';

interface AutomaticDiscussionOptionsModalAttrs extends IInternalModalAttrs {
    options: AutomaticDiscussionOptions
    onchange: (options: AutomaticDiscussionOptions) => void
}

export default class AutomaticDiscussionOptionsModal extends Modal<AutomaticDiscussionOptionsModalAttrs> {
    options!: AutomaticDiscussionOptions

    oninit(vnode: Vnode<AutomaticDiscussionOptionsModalAttrs, this>) {
        super.oninit(vnode);

        this.options = JSON.parse(JSON.stringify(this.attrs.options));
    }

    className() {
        return 'FormulaireModal FormulaireTheme';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title');
    }

    content() {
        return m('.Modal-body', [
            m('.Form-group', m('p', app.translator.trans(translationPrefix + 'introduction', {
                // Those aren't really translation parameters but it seems Flarum now removes them
                // so we add them back as parameter values
                ' title ': m('code', '{ title }'),
                ' content ': m('code', '{ content }'),
            }))),
            m(FormGroup, {
                label: m('label', app.translator.trans(translationPrefix + 'field.title')),
            }, m('input.FormControl', {
                type: 'text',
                value: this.options.title || '',
                oninput: withAttr('value', (value: string) => {
                    this.options.title = value;
                }),
            })),
            m(FormGroup, {
                label: m('label', app.translator.trans(translationPrefix + 'field.tags')),
                description: app.translator.trans(translationPrefix + 'field.tags-help'),
            }, m('input.FormControl', {
                type: 'text',
                value: this.options.tags || '',
                oninput: withAttr('value', (value: string) => {
                    this.options.tags = value;
                }),
            })),
            m(FormGroup, {
                label: m('label', app.translator.trans(translationPrefix + 'field.content')),
            }, m(RichTextField, {
                value: this.options.content || '',
                onchange: withAttr('value', (value: string) => {
                    this.options.content = value;
                }),
            })),
            m('.Form-group', Button.component({
                type: 'submit',
                className: 'Button Button--primary',
            }, app.translator.trans(translationPrefix + 'submit'))),
        ]);
    }

    onsubmit(event: Event) {
        event.preventDefault();

        this.attrs.onchange(this.options);
    }
}
